export default "__VITE_ASSET__c970a39c__"